import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useIntl } from "react-intl";
import { useAlert } from "../../helpers/useAlert";
import { alertServices } from "../../services/alertsServices";
import { AlertsList } from "../alerts-list/AlertsList";

export function AlertsView() {
  const [show, setShow] = useState<boolean>(false);
  const [hasPendingAlerts, setHasPendingAlerts] = useState<boolean>(false);
  const intl = useIntl();

  // Detect ALERT notification
  useEffect(() => {
    hasAnyAlert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const data = useAlert();
  useEffect(() => {
    if (data || !!hasPendingAlerts) {
      setShow(true);
    }
  }, [data, hasPendingAlerts]);
  
  const hasAnyAlert = useCallback(async () => {
    const response = await alertServices.hasAnyAlert();
    const data = response.data;
    if (!!data) {
      setHasPendingAlerts(true);
    }
  }, []);

  return (
    <>
      {show && (
        <Modal
          show={show}
          keyboard={false}
          size="lg"
          backdrop="static"
          centered
        >
          <Modal.Header className="bg-danger">
            <Modal.Title className="text-inverse-danger">
              {intl.formatMessage({ id: "ALERTS.NAME" })}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Start: Location Form*/}
            <Fragment>
              <AlertsList hideAlertsModal={setShow} showAlertModal={show} />
            </Fragment>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}
